<template>
  <RequiresPermission
    permission="view_platform_overview"
    fallback-route-name="merchantIndex"
  >
    <div class="flex w-full flex-col space-y-4">
      <BaseCard class="relative">
        <PlatformSummary source="beepaidgo" />
      </BaseCard>
      <BaseCard class="relative">
        <LastTransactions source="beepaidgo" />
      </BaseCard>

      <BaseCard class="relative">
        <WeeklyTransactionSummary source="beepaidgo" />
      </BaseCard>
    </div>
  </RequiresPermission>
</template>

<script setup lang="ts">
const { isLoggedIn } = useAuth()
const router = useRouter()

const { organizationConfig } = useOrganizationConfig()

whenever(
  () =>
    isLoggedIn.value &&
    organizationConfig.value &&
    !organizationConfig.value?.beepaidGoEnabled,
  () => {
    router.push({
      name: "dashboard",
    })
  },
  {
    immediate: true,
  }
)
</script>
